import type { IconList } from '@snowit/assets';
import type { MainNavRoute, MainPath, MainRoute } from '../types';

const CHANGELOGS_TABS = ['app', 'backend', 'pannello', 'web'] as const;
export type ChangelogsTabs = (typeof CHANGELOGS_TABS)[number];

const ICONS: Record<ChangelogsTabs, IconList> = {
  app: 'mobile',
  backend: 'service',
  pannello: 'gear',
  web: 'globe',
};

export const ChangelogsPath: MainPath = '/changelogs/:app';

export const ChangelogsRoutes: MainNavRoute[] = CHANGELOGS_TABS.map((route) => ({
  path: `/changelogs/${route}` as `/${MainRoute}`,
  label: `const.${route}`,
  type: 0, // admin only
  icon: ICONS[route],
}));
